<span>
  <his-table-config #tc
    #tableCtx="hisTableContext"
    style="display: inline-block;"
    enableFrozenColumns
    [columns]="configColumns"
    [enablePaginatorConfig]="showPaginator"
    [hisTableId]="tableId"
    disableTableIdGeneration
    [maxRows]="maxRows"
    (saved)="onSaved($event)">
  </his-table-config>
</span>